import React from 'react';
import PropTypes from 'prop-types';

import { uuid } from '../../utils/utils';

const propTypes = {
    id: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    value: PropTypes.any,
    name: PropTypes.string,
    required: PropTypes.bool,
    counts: PropTypes.string,
    className: PropTypes.string,
};
const defaultProps = {
    type: 'radio',
    onChange: () => {},
};

function RadioButton(props) {
    const {
        name,
        id,
        counts,
        className,
        disabled,
        label,
        onClick,
        onChange,
        value,
    } = props;

    let checkId = id || uuid();

    function classNames() {
        let classes = [];

        for (let i = 0; i < arguments.length; i++) {
            let arg = arguments[i];
            if (!arg) continue;

            let argType = typeof arg;

            if (argType === 'string' || argType === 'number') {
                classes.push(arg);
            } else if (Array.isArray(arg) && arg.length) {
                let inner = classNames.apply(null, arg);
                if (inner) {
                    classes.push(inner);
                }
            } else if (argType === 'object') {
                for (let key in arg) {
                    if (Object.prototype.hasOwnProperty.call(arg, key) && arg[key]) {
                        classes.push(key);
                    }
                }
            }
        }

        return classes.join(' ');
    }

    const classes = classNames(
        className,
        'prism-radio ',
        disabled && 'prism-radio--disabled'
    );

    return (
        <div className={classes}>
            <label onChange={onChange} className=" align-items-center d-flex">
                <input
                    id={checkId}
                    name={name || 'radio'}
                    // required={required || null}
                    type="radio"
                    onClick={onClick}
                    value={value}
                    {...props}
                />
                <label htmlFor={checkId} className=" itemCol">
                    {label}
                </label>
                {counts && (
                    <div className="d-flex ml-auto">
                        <span className="prism-radio__counts">{counts}</span>
                    </div>
                )}
            </label>
        </div>
    );
}

RadioButton.propTypes = propTypes;
RadioButton.defaultProps = defaultProps;
export default RadioButton;